import React from 'react';

const TECH_ENTITY_NAME = 'rAIn Automation, LLC';
const TECH_ENTITY_EMAIL = 'support@rainautomation.com';

const Footer: React.FC = () => (
  <footer
    className="bg-neutral-100 text-neutral-600 text-sm p-4 border-t"
    role="contentinfo"
    aria-label="Footer"
  >
    <div className="max-w-6xl mx-auto flex flex-col items-center space-y-3 text-center">
      {/* rAIn Branding */}
      <img
        src="/rain_idx_logo.png"
        alt="rAIn Automation IDX Logo"
        className="h-6"
        style={{ maxWidth: 140 }}
        loading="lazy"
      />

      {/* Technical Disclosure */}
      <p className="text-xs text-neutral-700">
        IDX Platform by <strong>{TECH_ENTITY_NAME}</strong> — real estate data tools powered by advanced automation.
        <br />
        Contact us at{' '}
        <a
          href={`mailto:${TECH_ENTITY_EMAIL}`}
          className="underline text-blue-700 hover:text-blue-800"
        >
          {TECH_ENTITY_EMAIL}
        </a>
      </p>

      {/* Legal Links */}
      <p className="text-xs text-neutral-500">
        Use of this website is subject to our{' '}
        <a href="/terms" className="underline hover:text-neutral-700">
          Terms of Use
        </a>{' '}
        and{' '}
        <a href="/privacy" className="underline text-blue-600 hover:text-blue-700">
          Privacy Policy
        </a>.
      </p>
    </div>
  </footer>
);

export default Footer;